<template>
  <div class="d-grid gap-8">
    <BaseCard
      v-if="companiesConfig.schemes !== '0'"
      :title="
        localStorage.translations.pages.sales_project['schemes_documents-sections']['chertezhi']
      "
      class-body="d-grid gap-5"
    >
      <v-form ref="formSchemes" lazy-validation v-model="validSchemes">
        <ProjectSchemesTable
          v-if="workDocsProjectSchemesAll.length || schemesUploadGo.length"
          :items="workDocsProjectSchemesAll"
          :itemsUpload="schemesUploadGo"
          :edit="schemesEdit"
          :schemeTypeList="workDocsSchemeTypeAll"
          :schemeClassList="workDocsSchemeClassAll"
          :workAreaList="workDocsWorkAreaAll"
          @schemesTableData="onSchemesTableData"
          ref="SchemeTable"
          :editShowPage="edit"
          :sticky="tableSticky"
        />
       <div v-else-if="!edit" class="secondary--text f18 mb-8">
        {{ localStorage.translations.pages.common.text['faylov-net-zagruzite'] }}
       </div>
      </v-form>
      <div v-if="edit">
        <div
          v-if="!schemesUploadGo.length && !workDocsProjectSchemesAll.length"
          class="secondary--text f18 mb-8"
        >
          {{ localStorage.translations.pages.common.text['faylov-net-zagruzite'] }}
        </div>
        <div class="d-flex flex-wrap gap-5">
          <template v-if="schemesEdit == false">
            <ButtonFileUpload
              :uploadStatus="fileUploadSchemesStatus"
              :text="
                localStorage.translations.pages.common.buttons[
                  fileUploadSchemesStatus ? 'fayl-y-zagruzhayutsya' : 'zagruzit'
                ]
              "
              :multiple="true"
              format="PDF"
              fileAccept=".pdf"
              @buttonFileUpload="onButtonFileUpload"
            />
            <EditBtn
              v-if="workDocsProjectSchemesAll.length"
              :big="true"
              :bigClick="onSchemesEdit"
              :disabled="fileUploadSchemesStatus"
            />
          </template>
          <template v-else>
            <BaseButton
              @click="onSchemesUpdate"
              :text="localStorage.translations.pages.common.buttons['sohranit']"
              :disabled="updateSchemesReady"
              default_icon="button-save"
            />
            <BaseButton
              @click="onSchemesEdit"
              :text="localStorage.translations.pages.common.buttons['otmenit']"
              :disabled="updateSchemesReady"
              reverse
            />
          </template>
        </div>
      </div>
    </BaseCard>
    <BaseCard
      v-if="companiesConfig.documents !== '0'"
      :title="
        localStorage.translations.pages.sales_project['schemes_documents-sections']['dokumenty']
      "
      class-body="d-grid gap-5"
    >
      <v-form ref="formDocuments" lazy-validation v-model="validDocuments">
        <ProjectDocumentsTable
          v-if="workDocsProjectDocumentsAll.length || documentsUploadGo.length"
          :items="workDocsProjectDocumentsAll"
          :itemsUpload="documentsUploadGo"
          :edit="documentsEdit"
          :documentTypeList="workDocsDocumentTypeAll"
          @documentsTableData="onDocumentsTableData"
          :editShowPage="edit"
          :sticky="tableSticky"
        />
       <div v-else-if="!edit" class="secondary--text f18 mb-8">
        {{ localStorage.translations.pages.common.text['faylov-net-zagruzite'] }}
       </div>
      </v-form>
      <div v-if="edit">
        <div
          v-if="!workDocsProjectDocumentsAll.length && !documentsUploadGo.length"
          class="secondary--text f18 mb-8"
        >
          {{ localStorage.translations.pages.common.text['faylov-net-zagruzite'] }}
        </div>
        <div class="d-flex flex-wrap gap-5">
          <template v-if="documentsEdit == false">
            <ButtonFileUpload
              :uploadStatus="fileUploadDocumentsStatus"
              :text="
                localStorage.translations.pages.common.buttons[
                  fileUploadDocumentsStatus ? 'fayl-y-zagruzhayutsya' : 'zagruzit'
                ]
              "
              :multiple="true"
              format="PDF"
              fileAccept=".pdf"
              @buttonFileUpload="onButtonFileUploadDocuments"
            />
            <EditBtn
              v-if="workDocsProjectDocumentsAll.length"
              :big="true"
              :bigClick="onDocumentsEdit"
              :disabled="fileUploadDocumentsStatus"
            />
          </template>
          <template v-else>
            <BaseButton
              @click="onDocumentsUpdate"
              :text="localStorage.translations.pages.common.buttons['sohranit']"
              :disabled="updateDocumentsReady"
              default_icon="button-save"
            />
            <BaseButton
              @click="onDocumentsEdit"
              :text="localStorage.translations.pages.common.buttons['otmenit']"
              :disabled="updateDocumentsReady"
              reverse
            />
          </template>
        </div>
      </div>
    </BaseCard>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ButtonFileUpload from 'components/ButtonFileUpload'
import EditBtn from 'components/EditBtn'
import ProjectSchemesTable from 'components/project/schemesAndDocuments/schemes/ProjectSchemesTable'
import ProjectDocumentsTable from 'components/project/schemesAndDocuments/documents/ProjectDocumentsTable'
import BaseCard from 'components/base/BaseCard'

export default {
  name: 'ProjectSchemesAndDocuments',
  props: ['createContinue', 'edit', 'tableSticky'],
  components: {
    BaseCard,
    ButtonFileUpload,
    ProjectSchemesTable,
    ProjectDocumentsTable,
    EditBtn,
  },
  data() {
    return {
      validSchemes: true,
      validDocuments: true,
      schemesUpload: [],
      schemesUploadGo: [],
      schemesTableData: null,
      schemesEdit: false,
      documentsUpload: [],
      documentsUploadGo: [],
      documentsTableData: null,
      documentsEdit: false,
      fileUploadSchemesStatus: false,
      fileUploadDocumentsStatus: false,
      updateSchemesReady: false,
      updateDocumentsReady: false,
      schemesEditDataDownloaded: false,
      documentsEditDataDownloaded: false,
      loadingData: false,
    }
  },
  created() {
    this.onDownloadData()
  },
  watch: {
    schemesEdit() {
      if (this.schemesEdit == true && this.schemesEditDataDownloaded == false) {
        Promise.all([
          this.onWorkDocsSchemeTypeAll(),
          this.onWorkDocsSchemeClassAll(),
          this.onWorkDocsWorkAreaAll(this.$route.params.id),
        ]).then(() => {
          this.schemesEditDataDownloaded = true
        })
      }
      if (!this.schemeEdit) {
        this.schemesTableData = null
      }
    },
    documentsEdit() {
      if (this.documentsEdit == true && this.documentsEditDataDownloaded == false) {
        this.onWorkDocsDocumentTypeAll().then(() => {
          this.documentsEditDataDownloaded = true
        })
      }
      if (!this.documentsEdit) {
        this.documentsTableData = null
      }
    },
  },
  mounted() {},
  computed: {
    ...mapGetters(['uploadProgress', 'companiesConfig']),
    ...mapGetters('workClientProject', ['workClientProjectShow']),
    ...mapGetters('workDocsProjectSchemes', ['workDocsProjectSchemesAll', 'uploadSchemesProgress']),
    ...mapGetters('workDocsSchemeType', ['workDocsSchemeTypeAll']),
    ...mapGetters('workDocsSchemeClass', ['workDocsSchemeClassAll']),
    ...mapGetters('workDocsWorkArea', ['workDocsWorkAreaAll']),
    ...mapGetters('workDocsProjectDocuments', ['workDocsProjectDocumentsAll']),
    ...mapGetters('workDocsDocumentType', ['workDocsDocumentTypeAll']),
    ...mapGetters('user', ['userData', 'userType']),
    checkUserProjectManager() {
      return this.userData && !!this.userData.employee
        ? this.userData.employee.id === this.workClientProjectShow.project_manager_employee_id
        : false
    },
    allDataReady() {
      return this.name !== null
    },
    apiDomain() {
      return this.$store.state.apiDomain
    },
    pageSalesProjectCreate() {
      return this.$route.name === 'SalesProjectCreate'
    },
  },
  methods: {
    ...mapActions(['uploadFile']),
    ...mapActions('workDocsProjectSchemes', [
      'onWorkDocsProjectSchemesAll',
      'onWorkDocsProjectSchemesCreate',
      'onWorkDocsProjectSchemesUpdate',
      'onWorkDocsProjectSchemesUploadFiles',
    ]),
    ...mapMutations('workDocsProjectSchemes', ['setWorkDocsProjectSchemesAll']),
    ...mapActions('workDocsProjectDocuments', [
      'onWorkDocsProjectDocumentsAll',
      'onWorkDocsProjectDocumentsCreate',
      'onWorkDocsProjectDocumentsUpdate',
      'onWorkDocsProjectDocumentsUploadFiles',
    ]),
    ...mapMutations('workDocsProjectDocuments', ['setWorkDocsProjectDocumentsAll']),
    ...mapActions('workDocsSchemeType', ['onWorkDocsSchemeTypeAll']),
    ...mapActions('workDocsSchemeClass', ['onWorkDocsSchemeClassAll']),
    ...mapActions('workDocsWorkArea', ['onWorkDocsWorkAreaAll']),
    ...mapActions('workDocsDocumentType', ['onWorkDocsDocumentTypeAll']),
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    onDownloadData() {
      if (this.$route.name === 'SalesProjectCreateContinue' || !this.pageSalesProjectCreate) {
        if (this.$route.params.id || this.workClientProjectShow) {
          this.loadingData = true
          Promise.all([
            this.onWorkDocsProjectSchemesAll(
              this.$route.params.id || this.workClientProjectShow.id,
            ),
            this.onWorkDocsProjectDocumentsAll(
              this.$route.params.id || this.workClientProjectShow.id,
            ),
          ]).then(() => {
            this.loadingData = false
          })
        }
      }
    },
    onSchemesEdit() {
      this.schemesEdit = !this.schemesEdit
    },
    onEdit() {
      this.schemesEdit = true
      this.documentsEdit = true
      return true
    },
    offEdit() {
      this.schemesEdit = false
      this.documentsEdit = false
      return true
    },
    onDocumentsEdit() {
      this.documentsEdit = !this.documentsEdit
    },
    onSchemesTableData(value) {
      this.schemesTableData = value.data
      delete value.data
      value.name = 'schemesTableData'
      this.onNavigationGuardianCheck({
        data: { schemesTableData: this.schemesTableData },
        overwrite: value.type !== 'edit' ? true : false,
        editingArrayData: value,
      })
    },
    onDocumentsTableData(value) {
      this.documentsTableData = value.data
      delete value.data
      value.name = 'documentsTableData'
      this.onNavigationGuardianCheck({
        data: { documentsTableData: this.documentsTableData },
        overwrite: value.type !== 'edit' ? true : false,
        editingArrayData: value,
      })
    },
    async onButtonFileUpload(data) {
      this.schemesUpload = data.files
      this.submitFileScheme()
    },
    async onButtonFileUploadDocuments(data) {
      this.documentsUpload = data.files
      this.submitFileDocument()
    },
    validateSchemes() {
      return this.$refs.formSchemes ? this.$refs.formSchemes.validate() : true
    },
    validateDocuments() {
      return this.$refs.formDocuments ? this.$refs.formDocuments.validate() : true
    },
    onSchemeUploadDrop() {
      this.schemesUploadGo = []
      this.fileUploadSchemesStatus = false
    },
    async onSchemesUpdate() {
      if (!this.schemesEdit) {
        await this.onSchemesEdit()
      }
      if (this.$refs.formSchemes)
        return new Promise(async (resolve, reject) => {
          if (this.validateSchemes()) {
            this.loadingData = true
            this.updateSchemesReady = true
            const changeData = this.$checkNavigationGuardianChange('schemesTableData')
            let requests = []
            for (let i in changeData) {
              if (changeData[i]) {
                requests.push(this.onWorkDocsProjectSchemesUpdate(this.schemesTableData[i]))
              }
            }
            if (requests.length) {
              Promise.all(requests)
                .then(async (resp) => {
                  await this.onWorkDocsProjectSchemesAll(
                    this.$route.params.id || this.workClientProjectShow.id,
                  )
                  this.schemesEdit = false
                  this.updateSchemesReady = false
                  this.$store.dispatch(
                    'popup/onMessage',
                    {
                      message:
                        this.localStorage.translations.pages.common.notifications[
                          'izmeneniya-uspeshno-sohraneny'
                        ],
                      IsError: false,
                    },
                    { root: true },
                  )
                  this.loadingData = false
                  resolve(resp)
                })
                .catch((err) => {
                  if (err.response && err.response.data.name[0]) {
                    this.$store.dispatch(
                      'popup/onMessage',
                      {
                        message:
                          this.localStorage.translations.pages.common.notifications[
                            'name_is_already_in_use'
                          ] +
                          ' ' +
                          JSON.parse(err.response.config.data).name,
                        IsError: true,
                      },
                      { root: true },
                    )
                  }
                  this.updateSchemesReady = false
                  this.loadingData = false
                  reject(err)
                })
            } else {
              this.loadingData = false
              this.schemesEdit = false
              this.updateSchemesReady = false
              resolve(true)
            }
          } else {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications[
                    'fill_in_required_fields'
                  ],
                IsError: true,
              },

              { root: true },
            )
            reject(false)
          }
        })
      else return true
    },
    async onDocumentsUpdate() {
      if (!this.documentsEdit) {
        await this.onDocumentsEdit()
      }
      if (this.$refs.formDocuments)
        return new Promise(async (resolve, reject) => {
          if (this.validateDocuments()) {
            this.loadingData = true
            this.updateDocumentsReady = true
            const changeData = this.$checkNavigationGuardianChange('documentsTableData')
            let requests = []
            for (let i in changeData) {
              if (changeData[i]) {
                requests.push(this.onWorkDocsProjectDocumentsUpdate(this.documentsTableData[i]))
              }
            }
            if (requests.length) {
              Promise.all(requests)
                .then(async (resp) => {
                  await this.onWorkDocsProjectDocumentsAll(
                    this.$route.params.id || this.workClientProjectShow.id,
                  )
                  this.documentsEdit = false
                  this.updateDocumentsReady = false
                  this.$store.dispatch(
                    'popup/onMessage',
                    {
                      message:
                        this.localStorage.translations.pages.common.notifications[
                          'izmeneniya-uspeshno-sohraneny'
                        ],
                      IsError: false,
                    },

                    { root: true },
                  )
                  this.loadingData = false
                  resolve(resp)
                })
                .catch((err) => {
                  if (err.response && err.response.data.name[0]) {
                    this.$store.dispatch(
                      'popup/onMessage',
                      {
                        message:
                          this.localStorage.translations.pages.common.notifications[
                            'name_is_already_in_use'
                          ] +
                          ' ' +
                          JSON.parse(err.response.config.data).name,
                        IsError: true,
                      },
                      { root: true },
                    )
                  }
                  this.loadingData = false
                  this.updateDocumentsReady = false
                  reject(err)
                })
            } else {
              this.loadingData = false
              this.documentsEdit = false
              this.updateDocumentsReady = false
              resolve(true)
            }
          } else {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications[
                    'fill_in_required_fields'
                  ],
                IsError: true,
              },

              { root: true },
            )
            reject(false)
          }
        })
      else return true
    },
    async submitFileScheme() {
      this.fileUploadSchemesStatus = true
      for (let i = 0; i < this.schemesUpload.length; ++i) {
        let formData = new FormData()
        formData.append('file', this.schemesUpload[i])
        let fileFullName = this.schemesUpload[i].name
        let fileName = fileFullName.substring(0, fileFullName.lastIndexOf('.'))
        let fileExtension = fileFullName.substring(
          fileFullName.lastIndexOf('.') + 1,
          fileFullName.length,
        )
        let size = this.$formatFileSizeUnits(this.schemesUpload[i].size)
        let nameCheck = this.workDocsProjectSchemesAll.filter((item) => item.name == fileName)
        this.schemesUploadGo.push({
          name: nameCheck.length ? fileName + '(1)' : fileName,
          status: 'progress',
          extension: fileExtension,
          size: size,
        })

        let objIndex = this.schemesUploadGo.findIndex(
          (obj) => obj.name == this.schemesUploadGo[i].name,
        )
        await this.onWorkDocsProjectSchemesUploadFiles({
          data: formData,
        })
          .then((response) => {
            let data = {
              project_id: this.$route.params.id || this.workClientProjectShow.id,
              name: nameCheck.length ? fileName + '(1)' : fileName,
              files: JSON.stringify([
                {
                  url: response.data.url,
                  extension: fileExtension,
                  size: size,
                },
              ]),
            }
            return this.onWorkDocsProjectSchemesCreate(data)
              .then((response) => {
                this.schemesUploadGo[objIndex].status = 'done'
              })
              .catch((err) => {
                this.schemesUploadGo[objIndex].status = 'error'
                this.$store.dispatch('deleteFile', {
                  url: JSON.parse(data.files)[0].url,
                })
              })
          })
          .catch((err) => {
            this.schemesUploadGo[objIndex].status = 'error'
          })
      }
      this.onWorkDocsProjectSchemesAll(this.$route.params.id).then((response) => {
        this.schemesUploadGo = []
        this.fileUploadSchemesStatus = false
      })
    },
    async submitFileDocument() {
      this.fileUploadDocumentsStatus = true
      for (let i = 0; i < this.documentsUpload.length; ++i) {
        let formData = new FormData()
        formData.append('file', this.documentsUpload[i])
        let fileFullName = this.documentsUpload[i].name
        let fileName = fileFullName.substring(0, fileFullName.lastIndexOf('.'))
        let fileExtension = fileFullName.substring(
          fileFullName.lastIndexOf('.') + 1,
          fileFullName.length,
        )
        let size = this.$formatFileSizeUnits(this.documentsUpload[i].size)
        let nameCheck = this.workDocsProjectDocumentsAll.filter((item) => item.name == fileName)
        this.documentsUploadGo.push({
          name: nameCheck.length ? fileName + '(1)' : fileName,
          status: 'progress',
          extension: fileExtension,
          size: size,
        })
        let objIndex = this.documentsUploadGo.findIndex(
          (obj) => obj.name == this.documentsUploadGo[i].name,
        )
        await this.onWorkDocsProjectDocumentsUploadFiles({
          data: formData,
        })
          .then((response) => {
            let data = {
              project_id: this.$route.params.id || this.workClientProjectShow.id,
              name: nameCheck.length ? fileName + '(1)' : fileName,
              files: JSON.stringify([
                {
                  url: response.data.url,
                  extension: fileExtension,
                  size: size,
                },
              ]),
            }
            return this.onWorkDocsProjectDocumentsCreate(data)
              .then((response) => {
                this.documentsUploadGo[objIndex].status = 'done'
              })
              .catch((err) => {
                this.documentsUploadGo[objIndex].status = 'error'
                this.$store.dispatch('deleteFile', {
                  url: JSON.parse(data.files)[0].url,
                })
              })
          })
          .catch((err) => {
            this.documentsUploadGo[objIndex].status = 'error'
          })
      }
      this.onWorkDocsProjectDocumentsAll(this.$route.params.id).then((response) => {
        this.fileUploadDocumentsStatus = false
        this.documentsUploadGo = []
      })
    },
  },
  beforeDestroy() {
    this.setWorkDocsProjectSchemesAll([])
    this.setWorkDocsProjectDocumentsAll([])
  },
}
</script>